export default __webpack_public_path__ + "static/media/model-icon.d9535d7e.svg";